/**
 * author: Patrick Vyn Badiang
 * 
 * description:
 * is the DOM
 */
import MainHeader from './utils/MainHeader.js';
import IntroSplash from './utils/IntroSplash.js';
import CssBaseline from '@mui/material/CssBaseline';

import { Route, Routes, BrowserRouter } from 'react-router-dom';

import { themeOptions } from './ThemeOptions.tsx';

import { ThemeProvider, createTheme } from '@mui/material/styles';

//utils
import MemberHighlight from './components/pages/memberPage/MemberHighlight.js';
import { Paper } from '@mui/material';
import BottomFooter from './utils/BottomFooter.js';
import Main from './components/pages/mainPage/Main.js';


//Pages
import BoardPage from './components/pages/boardPage/BoardPage';
import ConstitutionPage from './components/pages/constitutionPage/ConstitutionPage';
import ResourcesPage from './components/pages/resourcesPage/ResourcesPage';
import DonationPage from './components/pages/donationPage/DonationPage';
import LinksPage from './components/pages/linkPage/LinksPage.js';
import GalleryPage from './components/pages/galleryPage/GalleryPage.js';
import ScholarshipPage from './components/pages/scholarshipPage/ScholarshipPage.js';
import AteKuyaPage from './components/pages/ateKuyaPage/AteKuyaPage.js';
import AdminLogin from './components/pages/adminLogin/adminLogin.js';
import CalendarPage from './components/pages/calendarPage/CalendarPage.js';


function App() {
  const fasaName = "FASA at VT";
  const theme = createTheme(themeOptions);

  //V2
  return (
    
    <ThemeProvider theme={theme}>

        <CssBaseline />

        <IntroSplash />

        <BrowserRouter>
        <div>
          <MainHeader text = {fasaName}/>
        </div>
      <main>
        <Routes>
        
          <Route path ="/" element = {<Main theme = {theme}/>} />
          <Route path ="board" element = {<BoardPage theme = {theme}/>} />
          <Route path ="memberHighlight" element = {<MemberHighlight theme = {theme}/>} />
          <Route path = "constitution" element = {<ConstitutionPage theme = {theme}/>}/>
          <Route path = "resources" element = {<ResourcesPage theme = {theme}/>}/>
          <Route path = "donation" element = {<DonationPage theme = {theme}/>}/>
          <Route path = "links" element = {<LinksPage theme = {theme}/>}/>
          <Route path = "gallery" element = {<GalleryPage theme = {theme}/>}/>
          <Route path = "scholarship" element = {<ScholarshipPage theme = {theme}/>}/>
          <Route path = "ate-kuya" element = {<AteKuyaPage theme = {theme}/>}/>
          <Route path = "calendar" element = {<CalendarPage theme = {theme}/>}/>
          <Route path = "EUGNDSKGIQPFNDahwd102bc72" element = {<AdminLogin theme = {theme}/>}/>

          
        </Routes>
      </main>
      <Paper sqaure sx = {{width: 'full', bgcolor: 'primary.main'}}>
                <BottomFooter/>
          </Paper>
    </BrowserRouter>
    </ThemeProvider>
    

      
  );
}

export default App;

